<!-- Card with a short description and link for Values Questionnaire or Wizard -->
<template>
  <div class="tw-bg-indigo-50 tw-shadow-lg tw-p-5 tw-rounded-md tw-flex tw-flex-col tw-justify-between tw-items-stretch tw-gap-3 tw-max-w-lg">
    <h2 class="tw-text-xl tw-font-bold">
      {{ name }}
    </h2>
    <p>{{ description }}</p>
    <CopyableLink :link="mainLink" />

    <div class="tw-flex tw-text-xs tw-gap-3 tw-pt-5">
      <a
        v-for="link in otherLinks"
        class="tw-underline tw-text-slate-500"
        :href="link.url"
      >
        {{ link.name }}
      </a>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import CopyableLink from '@frontend/dash3/js/components/CopyableLink.vue';

export default {
  name: 'ValuesInputCard',
  components: { CopyableLink },
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    mainLink: {
      type: String,
      required: true,
    },
    otherLinks: {
      type: Array,
      required: false,
    },
  },
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
